import { useIntl } from "react-intl";
import { BannerText } from "../../components/BannerText/BannerText";
import { Index, IndexSection } from "../../components/Index/Index";
import { PositionedImage } from "../../components/PositionedImage/PositionedImage";
import "./Terms.scss";
import { Layout } from "../../components";
import ReactGA from "react-ga4";

export const Terms = () => {
  ReactGA.send({ hitType: "pageview", page: "/terms-conditions" });

  const intl = useIntl();
  const TERMS_AND_CONDITIONS_COUNT = parseInt(
    intl.formatMessage({ id: "termsPage.quantity" })
  );
  return (
    <Layout title="Términos y condiciones">
      <div className="terms-and-conditions-page">
        <PositionedImage
          image={require("../../assets/images/img_001.png")}
          width="722px"
          top="100px"
          right="0"
        />

        <PositionedImage
          image={require("../../assets/images/img_003.png")}
          width="722px"
          top="50%"
          left="0"
        />

        <PositionedImage
          image={require("../../assets/images/img_002.png")}
          width="722px"
          top="85%"
          right="0"
        />

        <div className="layout-container flex-grid ">
          <div className="banner-section flex-grid__cols-4 flex-grid__cols__offset-4 flex-grid__mobile__cols-6 flex-grid__mobile__cols__offset-none">
            <BannerText
              title={intl.formatMessage({ id: "termsPage.header.title" })}
              subtitle={intl.formatMessage({
                id: "termsPage.header.subtitle",
              })}
            />
          </div>

          <div className="flex-grid__cols-12">
            <Index offset={10}>
              {[...Array(TERMS_AND_CONDITIONS_COUNT)].map((el, index) => (
                <IndexSection
                  title={`${index + 1}. ${intl.formatMessage({
                    id: `termsPage.section${index + 1}.title`,
                  })}`}
                  sectionKey={`section_${index + 1}`}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: intl.formatMessage({
                        id: `termsPage.section${index + 1}.content`,
                      }),
                    }}
                  ></div>
                </IndexSection>
              ))}
            </Index>
          </div>
        </div>
      </div>
    </Layout>
  );
};
